// src/components/Utils/AnalyticsTracker.tsx

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        ReactGA.initialize('G-EMLZ16YWYC');
    }, []);

    useEffect(() => {
        // Send a pageview event whenever the path changes
        ReactGA.send({ 
            hitType: "pageview", 
            page: location.pathname + location.search,
            title: document.title 
        });
    }, [location]);

    return null;
};

export default AnalyticsTracker;